<template>
        <div v-on:mousemove="updateMouseCoordinates">
            <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 12px;">
                <h2 class="mb-0">Relatório de JOB</h2>
                <v-btn outlined color="primary" @click="$router.push('/relatorios#comercial')">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar ao menu
                </v-btn>
            </div>
            <div class="d-flex w-100">
                <form class="w-100 flex-grow-1 d-flex mt-5 mb-5">
                    <v-row>
                        <v-col cols="5" sm="6" md="5">
                            <v-text-field
                                v-model="filter.dataInicio"
                                type="date"
                                chips
                                clearable
                                hide-details
                                hide-selected
                                label="Search"
                                solo
                                @input="getRelatorioJob"
                            />
                        </v-col>
                        <v-col cols="5" sm="6" md="5">
                            <v-text-field
                                v-model="filter.dataFim"
                                type="date"
                                chips
                                clearable
                                hide-details
                                hide-selected
                                label="Search"
                                solo
                                @input="getRelatorioJob"
                            />
                        </v-col>
                        
                        <v-col cols="2" sm="2" md="1">

                            <v-menu
                                :close-on-content-click="false"
                                location="end"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" large icon color="primary">
                                        <v-icon>mdi-filter</v-icon>
                                    </v-btn>
                                </template>

                                <v-card min-width="500">

                                    <v-card-title>
                                        Filtro
                                    </v-card-title>

                                    <v-card-text>
                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="JOB" 
                                            solo 
                                            v-model="filter.job"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            chips clearable 
                                            hide-details
                                            hide-selected 
                                            label="Cliente" 
                                            class="mt-5 mb-5"
                                            solo 
                                            v-model="filter.cliente"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            chips 
                                            clearable 
                                            hide-details
                                            hide-selected 
                                            label="Segmento de Mercado" 
                                            class="mt-5 mb-5"
                                            solo 
                                            v-model="filter.segmento"
                                        >
                                        </v-text-field>

                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn variant="text">
                                            Cancel
                                        </v-btn>
                                        <v-btn color="primary" variant="text" @click="getRelatorioJob">
                                            Filtrar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                            </v-menu>
                        </v-col>

                    </v-row>

                </form>
                
                <div class="text-center mt-5 ml-5">
                    <v-menu>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary"
                                v-on="on" 
                                large
                            >
                                Gerar Relatorio
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(item, index) in actions"
                                :key="index"
                                :value="index"
                                @click="item.handle"
                                class="cursor-pointer"
                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>

                    </v-menu>
                </div>

            </div>
            
            <v-simple-table dense >
                <thead>
                    <tr>
                        <th>CÓD./PED</th>
                        <th>Abertura</th>
                        <th>Encerramento</th>
                        <th>Cliente/Descrição</th>
                        <th>Vend/Coord</th>
                        <th>Valor Job</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dado in dadosTabela" :key="dado._id" @click="handleRowClick(dado)" style="cursor: pointer;">
                        <template v-if="!dado.revisoes">
                            <td style="padding: 20px" width="100"><strong>{{ dado.code }}</strong> / {{ dado.pedidoCompra }}</td>
                            <td>
                                {{ dado.dataAbertura ? new Date(dado.dataAbertura).toLocaleDateString() : '' }}
                            </td>
                            <td>
                                {{ dado?.dataEncerramento ? new Date(dado?.dataEncerramento || '').toLocaleDateString() : ''}}
                            </td>
                            <td>
                                {{ dado.clienteNome || "Cliente Não Informado" }} <br /> / {{ dado.description }}
                            </td>
                            <td>-</td>
                            <td>
                                {{  Number(dado.valorJob).toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}}
                            </td>
                        </template>

                        <template v-else>
                            <td style="padding: 20px"><strong>{{ dado.code }}</strong> / {{ dado.revisoes.pedidoCompra }}</td>
                            <td>
                                {{ dado.revisoes.dataAbertura ? new Date(dado.revisoes.dataAbertura).toLocaleDateString() : '' }}
                            </td>
                            <td>
                                {{ dado.revisoes?.dataEncerramento ? new Date(dado.revisoes?.dataEncerramento).toLocaleDateString() : '' }}
                            </td>
                            <td>
                                {{ dado.clienteNome || "Cliente Não Informado" }} <br /> / {{ dado.revisoes.description }}
                            </td>
                             <td>-</td>
                            <td>
                                {{ Number(dado.valorJob).toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    }) }}
                            </td>
                        </template>

                    </tr>
                </tbody>
            </v-simple-table>

            <v-menu
                v-model="rowMenu.showMenu"
                :position-x="rowMenu.menuX"
                :position-y="rowMenu.menuY"
            >
                <v-list dense rounded>
                    <v-list-item
                        link
                        @click="openJobCodeView = true"
                    >
                        Gerar relatorio do JOB
                    </v-list-item>
                </v-list>
            </v-menu>

            <div v-show="mostrarPdf" class="w-100 pdf-content" ref="conteudoPDF">
                <job-pdf-view :data="dadosTabela" />
            </div>

            <job-code-view 
                :is-open="openJobCodeView"
                :job="jobSelected"
                @cancel="openJobCodeView = false"
            />

            <job-reference-view 
                :is-open="openJobReference"
                :listJobs="dadosTabela"
                @cancel="openJobReference = false"
            />

            <job-faturamento-view 
                :open="openJobFaturamentoView"
                :listJobs="dadosTabela"
                @cancel="openJobFaturamentoView = false"
            />

            <resumo-comercial 
                :isOpen="openResumoComercial"
                :salesOrderData="salesOrderData"
                @cancel="openResumoComercial = false"
            />

        </div>
</template>

<script>
import Vue from 'vue';
import * as XLSX from 'xlsx'
import moment from 'moment';
import JobPdfView from './JobPdfView.vue';
import html2pdf from 'html2pdf.js'
import JobCodeView from './JobCodeView.vue';
import JobReferenceView from './JobReferenceView.vue';
import jobFaturamentoView from './jobFaturamentoView.vue';
import ResumoComercial from './ResumoComercial.vue';

export default {
    components: { JobPdfView, JobCodeView, JobReferenceView, jobFaturamentoView, ResumoComercial },
    name: 'RelatorioJobView',
    data() {
        return {
            salesOrderData: [],
            openResumoComercial: false,
            openJobFaturamentoView: false,
            openJobCodeView: false,
            openJobReference: false,
            mostrarPdf: false,
            filter: {
                dataInicio: '',
                dataFim: '',
                job: '',
                cliente: '',
                segmento: ''
            },
            dadosTabela: [],
            actions: [
                { title: 'Exportar PDF', handle: this.exportPdf },
                { title: 'Resumo Comercial', handle: () => {
                    this.openResumoComercial = true
                    this.salesOrderData = this.dadosTabela.map((data) => {
                        return data.salesOrder[0]
                    })
                } },
                { title: 'Exportar Relatório de Referencia', handle: () => this.openJobReference = true },
                { title: 'Exportar Relatório de Faturamento', handle: () => this.openJobFaturamentoView = true },
                { title: 'Exportar Excel', handle: this.exportExcel },
            ],
            rowMenu: {
                showMenu: false,
                closeOnContentClick: false,
                x: 0,
                y: 0,
                menuX: 0,
                menuY: 0,
            },
            rowMenuOpen: false,
            jobSelected: null
        };
    },
    methods: {
        async getRelatorioJob() {
            const response = await Vue.prototype.$http.post('/View/run', {
                    params: [
                        { dataType: "String", name: "dataInicio", value: this.filter.dataInicio ? moment(this.filter.dataInicio).format('YYYY-MM-DD') : moment('1970-01-01').format('YYYY-MM-DD') },
                        { dataType: "String", name: "dataFim", value: this.filter.dataFim ? moment(this.filter.dataFim).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') },
                        { dataType: "string", name: "codigo", value: this.filter.job},
                        { dataType: "string", name: "cliente", value: this.filter.cliente.toUpperCase() },
                        { dataType: "string", name: "segmento", value: this.filter.segmento }
                    ],
                    viewId: "d6b789aa-34e6-4403-a5b8-7ee19c20efb8",
                    page: 1,
                    limit: 3000000

            })
            this.dadosTabela = response.data.data.data
        },

        timeout(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },

        updateMouseCoordinates(event) {
            this.rowMenu.x = event.clientX;
            this.rowMenu.y = event.clientY;
        },

        async openRowMenu() {
            await this.timeout(100);
            this.rowMenu.menuX = this.rowMenu.x;
            this.rowMenu.menuY = this.rowMenu.y;

            this.$nextTick(() => {
                this.rowMenu.showMenu = true;
            });
        },

        async handleRowClick(row){
            console.log('dado >>> ', row)
            this.jobSelected = row
            await this.openRowMenu();
        },

        // SCRIPT
        exportPdf() {
            this.mostrarPdf = true;

            this.$nextTick(() => {
                const elemento = this.$refs.conteudoPDF;
                html2pdf()
                .set({
                    margin: 10,
                    filename: 'Relatorio-Jobs.pdf',
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
                })
                .from(elemento)
                .save()
                .then(() => {
                    this.mostrarPdf = false;
                });
            });
        },

        exportExcel() {

            const dataRelatorio = this.dadosTabela.map((item) => {

                if(!item.revisoes){
                    return {
                        'Código': item.code,
                        'Abertura': item.dataAbertura ? new Date(item.dataAbertura).toLocaleDateString() : '',
                        'Encerramento': item.dataEncerramento ? new Date(item.dataEncerramento) : '',
                        'Cliente/Descrição': item.clienteNome + ' / ' + item.description,
                        'Vendedor': '',
                        'Valor Job': Number(item.valorJob).toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })
                    }
                } else {
                    return {
                        'Código': item.revisoes.code,
                        'Abertura': item.revisoes.dataAbertura ? new Date(item.revisoes.dataAbertura).toLocaleDateString() : '',
                        'Encerramento': item.revisoes.dataEncerramento ? new Date(item.revisoes.dataEncerramento).toLocaleDateString() : '',
                        'Cliente/Descrição': item.revisoes.clienteNome + '/' + item.revisoes.description,
                        'Vendedor': '',
                        'Valor Job': Number(item.revisoes.valorJob).toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })
                    }
                }
            })

            const ws = XLSX.utils.json_to_sheet(dataRelatorio)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Relatório JOB')

            // Cria e baixa o arquivo
            XLSX.writeFile(wb, 'JOBS.xlsx')

        }
    }
};
</script>

<style scoped>

#conteudoPDF {
  display: none;
}

.pdf-content {
  font-family: 'Arial', sans-serif;
}

@media print {
  #conteudoPDF {
    display: block !important;
  }
}
</style>
